<span class="label">{{ label }}</span>
<ng-container *ngIf="showText"
  ><span class="text">{{ text ? text : '&hellip;' }} {{ additionalText ? additionalText : '' }}</span></ng-container
>
<ng-container *ngIf="showOptInTemplate && !showText">
  <hf-opt-in-out [optedIn]="optInValue" class="text"></hf-opt-in-out>
</ng-container>
<ng-container *ngIf="showContactNote">
  <hf-contact-note [contactNote]="contactNote"></hf-contact-note>
</ng-container>
<ng-content></ng-content>
